// LogoWinarq — usa PNG con fondo transparente
// dark=true → logo original (negro+naranja sobre fondo claro)
// dark=false → filter invert para fondos oscuros

export function LogoWinarq({ height = 44, dark = true, style = {} }) {
  return (
    <img
      src="/logo_winarq.png"
      alt="WINARQ"
      style={{
        height,
        width: "auto",
        display: "block",
        objectFit: "contain",
        filter: dark ? "none" : "brightness(0) invert(1) sepia(1) saturate(5) hue-rotate(340deg)",
        ...style,
      }}
    />
  );
}

export function LogoIcono({ size = 32, dark = true }) {
  return (
    <img
      src="/logo_winarq.png"
      alt="W"
      style={{
        height: size,
        width: size,
        objectFit: "contain",
        objectPosition: "center",
        display: "block",
        filter: dark ? "none" : "brightness(0) invert(1)",
      }}
    />
  );
}

export default LogoWinarq;
